// code from gpt
const render = () => {
	return `
		<script>
			var userAgentInfo = navigator.userAgent;
			var agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
			window.isDesktop = true;
			for (var i = 0; i < agents.length; i++) {
				if (userAgentInfo.indexOf(agents[i]) > 0) {
					window.isDesktop = false;
					break;
				}
			}
			if (userAgentInfo.indexOf("compatible") > -1 && userAgentInfo.indexOf("MSIE") > -1) {
				window.isDesktop = true;
			}
		</script>
	`	
};

export default render;
